import { configure } from "mobx";
import { AnalyticsStore } from "./analytics";
import { AppStore } from "./app";
import { AuthStore } from "./auth";
import { DashboardStore } from "./dashboard";
import { HistoryStore } from "./history";
import { LoggingStore } from "./logging";
import { OperationsStore } from "./operations";
import { ParametersStore } from "./parameters";
import { PopupStore } from "./popup";
import { ProfileStore } from "./profile";
import { WalletStore } from "./wallet";

export class RootStore {
  private _analytics: AnalyticsStore;
  private _app: AppStore;
  private _auth: AuthStore;
  private _dashboard: DashboardStore;
  private _history: HistoryStore;
  private _logging: LoggingStore;
  private _operations: OperationsStore;
  private _parameters: ParametersStore;
  private _popup: PopupStore;
  private _profile: ProfileStore;
  private _wallet: WalletStore;

  constructor() {
    this._analytics = new AnalyticsStore(this);
    this._app = new AppStore(this);
    this._auth = new AuthStore(this);
    this._dashboard = new DashboardStore(this);
    this._history = new HistoryStore(this);
    this._logging = new LoggingStore(this);
    this._operations = new OperationsStore(this);
    this._parameters = new ParametersStore(this);
    this._popup = new PopupStore(this);
    this._profile = new ProfileStore(this);
    this._wallet = new WalletStore(this);
  }

  public get analytics(): AnalyticsStore {
    return this._analytics;
  }

  public get app(): AppStore {
    return this._app;
  }

  public get auth(): AuthStore {
    return this._auth;
  }

  public get dashboard(): DashboardStore {
    return this._dashboard;
  }

  public get history(): HistoryStore {
    return this._history;
  }

  public get logging(): LoggingStore {
    return this._logging;
  }

  public get operations(): OperationsStore {
    return this._operations;
  }

  public get parameters(): ParametersStore {
    return this._parameters;
  }

  public get popup(): PopupStore {
    return this._popup;
  }

  public get profile(): ProfileStore {
    return this._profile;
  }

  public get wallet(): WalletStore {
    return this._wallet;
  }
}

configure({ enforceActions: "never" });
